// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapboxgl-ctrl-geocoder {
  right: 0;
  top: 60px;
  z-index: 1
}

.map-container {
  height: 100vh; 
  width: 100%;
  position: absolute; 
  top: 0; 
  bottom: 0;
  width: 100%;
  overflow: hidden;
}

.popup {
  max-width: 200px;
}

.popup-description {
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 10px;
}

.popup-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.popup-close-button {
    cursor: pointer;
    color: green;
    font-size: 25px;
    margin-left: 10px;
    margin-top: -5px;
}

.popup-header {
  display: flex;
  align-items: center; 
  justify-content: space-between;
  position: relative;
}

.popup-title-modal {
  text-align: center;
  margin-bottom: 20px;
  font-family: Arial, Helvetica, sans-serif;
}

.popup-content {
  display: flex;
}

.popup-left {
  flex: 1 1;
}

.popup-right {
  flex: 1 1;
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
  margin-left: 50px;
}

.popup-right iframe {
  margin-bottom: 30px;
}

.popup-read-more-button-6 {
  margin-top: 10px;
}

.popup-close-buttonModal {
  display: block;
  position: absolute;
  top: 35px;
  right: 20px;
  padding: 10px 20px 10px 20px;
  background-color: #c1eeaa;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.popup-close-buttonModal:hover {
  background-color: #c7ee97;
}

.popup-descriptionModalimg {
  font-size: 20px;
  line-height: 2;
  margin-top: 50px;
  margin-left: 10px;
  height: 360px;
  margin-bottom: 20px;
}

.popup-descriptionModal {
  margin-bottom: 20px;
}

.icono-tipo{
  display: block;
  position: absolute;
  top: 20px;
  background-color: rgb(242, 242, 242);
  border-radius: 5px;
  padding: 10px;
}

.icon {
  margin-right: 8px; 
}

.tab-popup {
  text-align: center;
  overflow: hidden;
  background-color: #f1f1f1;
  border-radius: 3px;
}

.tablinks {
  background-color: inherit;
  float: none;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.3s;
  padding: 14px 0; 
  width: 50%; 
  text-align: center; 
}

.tablinks:hover {
  background-color: #c7ee97;
}

.tablinks.active {
  background-color: #c1eeaa;
}

.tabcontent-popup {
  display: none;
  padding: 6px 12px;
  border-top: none;
}

.tabcontent-popup.active {
  display: block;
}

.icono-y-texto {
  display: flex;
  align-items: center;
  border-radius: 5px;
  margin-top: 20px !important;
}

.separator {
  border: 0;
  border-top: 1px solid #ccc;
  margin: 10px 0; 
}

.icono-y-texto h3 {
  margin-left: 10px; 
}

.icono-info {
  margin-left: 20px;
}

.comment-container {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #ccc;
  margin-top: 20px !important;
  width: 75%;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  margin-left: 50px;
}

.comment-icon-text {
  display: flex;
  align-items: center;
}

.comment-description {
  margin-top: 10px;
  margin-left: 40px;
  color: #666;
}

.info {
  margin-left: 40px;
  margin-top: -25px;
}

.p-informacion {
  margin-left: 30px !important;
}

.map-overlay {
  position: absolute;
  top: 60%;
  left: 25%;
  width: 70%;
  height: 40%;
  pointer-events: none;
}

.overlay-image-ue,
.overlay-image-min {
  position: absolute;
}

.overlay-image-ue {
  top: 70%; 
  left: 60%; 
}

.overlay-image-min {
  top: 70%; 
  left: 60%; 
}

.mapboxgl-ctrl-logo,
.mapboxgl-ctrl-attrib-inner {
  display: none !important;
}

.responsive-iframe {
  width: 100%;
  height: 250px;
}

@media (max-width: 390px) {
  .popup-description {
    font-size: 16px;
  }

  .popup-title {
    font-size: 14px;
  }

  .popup-right {
    margin-left: 20px;
  }

  .responsive-iframe {
    height: 180px;
  }

  .comment-container {
    margin-left: 10px;
    width: 90%;
  }

  .overlay-image-ue,
  .overlay-image-min {
    width: 80%;
    top: 85%;
    left: 10%;
  }
}

@media (max-width: 398px) {
  .mapboxgl-ctrl-geocoder {
    top: 50px;
  }

  .map-container {
    height: calc(100vh - 50px);
  }

  .popup-close-buttonModal {
    top: 20px;
  }

  .popup-title-modal {
    margin-top: 55px;
  }

  .popup-description {
    font-size: 16px;
  }

  .popup-title {
    font-size: 14px;
  }

  .popup-right {
    margin-left: 20px;
  }

  .popup-content {
    flex-direction: column; 
  }
  .responsive-iframe {
    height: 180px;
  }

  .comment-container {
    margin-left: 20px;
    width: 70%;
  }

  .overlay-image-ue,
  .overlay-image-min {
    width: 50%; 
    top: 90%;
  }

  .overlay-image-ue {
    left: 30%;
  }

  .overlay-image-min {
    left: -25%;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .mapboxgl-ctrl-geocoder {
    top: 50px;
  }

  .map-container {
    height: calc(100vh - 50px);
  }

  .popup-content {
    flex-direction: column; 
  }

  .overlay-image-ue,
  .overlay-image-min {
    width: 50%; 
    top: 90%;
  }

  .overlay-image-ue {
    left: 35%;
  }

  .overlay-image-min {
    left: -20%;
  }

  .responsive-iframe {
    width: 90%;
    height: 220px;
    margin-top: 20px;
  }

  .comment-container {
    margin-left: 10px;
  }
}

@media (min-width: 1440px) and (max-width: 1600px) {
  .responsive-iframe {
    width: 600px;
    height: 250px;
    margin-top: 30px;
    margin-left: -20px;
  }

  .comment-container {
    width: 75%;
    margin-left: 50px;
  }

  .overlay-image-ue,
  .overlay-image-min {
    width: 30%; 
  }

  .overlay-image-ue {
    top: 50%;
    left: 70%;
  }

  .overlay-image-min {
    top: 70%;
    left: 70%;
  }
}

@media (min-width: 1769px) {
  .overlay-image-ue,
  .overlay-image-min {
    width: 30%; 
  }

  .overlay-image-ue {
    top: 50%;
    left: 70%;
  }

  .overlay-image-min {
    top: 70%;
    left: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/map.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,SAAS;EACT;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;;IAEE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;;IAEE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;AACF","sourcesContent":[".mapboxgl-ctrl-geocoder {\n  right: 0;\n  top: 60px;\n  z-index: 1\n}\n\n.map-container {\n  height: 100vh; \n  width: 100%;\n  position: absolute; \n  top: 0; \n  bottom: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.popup {\n  max-width: 200px;\n}\n\n.popup-description {\n  font-size: 20px;\n  line-height: 1.5;\n  margin-bottom: 10px;\n}\n\n.popup-title {\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.popup-close-button {\n    cursor: pointer;\n    color: green;\n    font-size: 25px;\n    margin-left: 10px;\n    margin-top: -5px;\n}\n\n.popup-header {\n  display: flex;\n  align-items: center; \n  justify-content: space-between;\n  position: relative;\n}\n\n.popup-title-modal {\n  text-align: center;\n  margin-bottom: 20px;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.popup-content {\n  display: flex;\n}\n\n.popup-left {\n  flex: 1;\n}\n\n.popup-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column; \n  align-items: flex-start;\n  margin-left: 50px;\n}\n\n.popup-right iframe {\n  margin-bottom: 30px;\n}\n\n.popup-read-more-button-6 {\n  margin-top: 10px;\n}\n\n.popup-close-buttonModal {\n  display: block;\n  position: absolute;\n  top: 35px;\n  right: 20px;\n  padding: 10px 20px 10px 20px;\n  background-color: #c1eeaa;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.popup-close-buttonModal:hover {\n  background-color: #c7ee97;\n}\n\n.popup-descriptionModalimg {\n  font-size: 20px;\n  line-height: 2;\n  margin-top: 50px;\n  margin-left: 10px;\n  height: 360px;\n  margin-bottom: 20px;\n}\n\n.popup-descriptionModal {\n  margin-bottom: 20px;\n}\n\n.icono-tipo{\n  display: block;\n  position: absolute;\n  top: 20px;\n  background-color: rgb(242, 242, 242);\n  border-radius: 5px;\n  padding: 10px;\n}\n\n.icon {\n  margin-right: 8px; \n}\n\n.tab-popup {\n  text-align: center;\n  overflow: hidden;\n  background-color: #f1f1f1;\n  border-radius: 3px;\n}\n\n.tablinks {\n  background-color: inherit;\n  float: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  transition: 0.3s;\n  padding: 14px 0; \n  width: 50%; \n  text-align: center; \n}\n\n.tablinks:hover {\n  background-color: #c7ee97;\n}\n\n.tablinks.active {\n  background-color: #c1eeaa;\n}\n\n.tabcontent-popup {\n  display: none;\n  padding: 6px 12px;\n  border-top: none;\n}\n\n.tabcontent-popup.active {\n  display: block;\n}\n\n.icono-y-texto {\n  display: flex;\n  align-items: center;\n  border-radius: 5px;\n  margin-top: 20px !important;\n}\n\n.separator {\n  border: 0;\n  border-top: 1px solid #ccc;\n  margin: 10px 0; \n}\n\n.icono-y-texto h3 {\n  margin-left: 10px; \n}\n\n.icono-info {\n  margin-left: 20px;\n}\n\n.comment-container {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  margin-top: 20px !important;\n  width: 75%;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\n  margin-left: 50px;\n}\n\n.comment-icon-text {\n  display: flex;\n  align-items: center;\n}\n\n.comment-description {\n  margin-top: 10px;\n  margin-left: 40px;\n  color: #666;\n}\n\n.info {\n  margin-left: 40px;\n  margin-top: -25px;\n}\n\n.p-informacion {\n  margin-left: 30px !important;\n}\n\n.map-overlay {\n  position: absolute;\n  top: 60%;\n  left: 25%;\n  width: 70%;\n  height: 40%;\n  pointer-events: none;\n}\n\n.overlay-image-ue,\n.overlay-image-min {\n  position: absolute;\n}\n\n.overlay-image-ue {\n  top: 70%; \n  left: 60%; \n}\n\n.overlay-image-min {\n  top: 70%; \n  left: 60%; \n}\n\n.mapboxgl-ctrl-logo,\n.mapboxgl-ctrl-attrib-inner {\n  display: none !important;\n}\n\n.responsive-iframe {\n  width: 100%;\n  height: 250px;\n}\n\n@media (max-width: 390px) {\n  .popup-description {\n    font-size: 16px;\n  }\n\n  .popup-title {\n    font-size: 14px;\n  }\n\n  .popup-right {\n    margin-left: 20px;\n  }\n\n  .responsive-iframe {\n    height: 180px;\n  }\n\n  .comment-container {\n    margin-left: 10px;\n    width: 90%;\n  }\n\n  .overlay-image-ue,\n  .overlay-image-min {\n    width: 80%;\n    top: 85%;\n    left: 10%;\n  }\n}\n\n@media (max-width: 398px) {\n  .mapboxgl-ctrl-geocoder {\n    top: 50px;\n  }\n\n  .map-container {\n    height: calc(100vh - 50px);\n  }\n\n  .popup-close-buttonModal {\n    top: 20px;\n  }\n\n  .popup-title-modal {\n    margin-top: 55px;\n  }\n\n  .popup-description {\n    font-size: 16px;\n  }\n\n  .popup-title {\n    font-size: 14px;\n  }\n\n  .popup-right {\n    margin-left: 20px;\n  }\n\n  .popup-content {\n    flex-direction: column; \n  }\n  .responsive-iframe {\n    height: 180px;\n  }\n\n  .comment-container {\n    margin-left: 20px;\n    width: 70%;\n  }\n\n  .overlay-image-ue,\n  .overlay-image-min {\n    width: 50%; \n    top: 90%;\n  }\n\n  .overlay-image-ue {\n    left: 30%;\n  }\n\n  .overlay-image-min {\n    left: -25%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .mapboxgl-ctrl-geocoder {\n    top: 50px;\n  }\n\n  .map-container {\n    height: calc(100vh - 50px);\n  }\n\n  .popup-content {\n    flex-direction: column; \n  }\n\n  .overlay-image-ue,\n  .overlay-image-min {\n    width: 50%; \n    top: 90%;\n  }\n\n  .overlay-image-ue {\n    left: 35%;\n  }\n\n  .overlay-image-min {\n    left: -20%;\n  }\n\n  .responsive-iframe {\n    width: 90%;\n    height: 220px;\n    margin-top: 20px;\n  }\n\n  .comment-container {\n    margin-left: 10px;\n  }\n}\n\n@media (min-width: 1440px) and (max-width: 1600px) {\n  .responsive-iframe {\n    width: 600px;\n    height: 250px;\n    margin-top: 30px;\n    margin-left: -20px;\n  }\n\n  .comment-container {\n    width: 75%;\n    margin-left: 50px;\n  }\n\n  .overlay-image-ue,\n  .overlay-image-min {\n    width: 30%; \n  }\n\n  .overlay-image-ue {\n    top: 50%;\n    left: 70%;\n  }\n\n  .overlay-image-min {\n    top: 70%;\n    left: 70%;\n  }\n}\n\n@media (min-width: 1769px) {\n  .overlay-image-ue,\n  .overlay-image-min {\n    width: 30%; \n  }\n\n  .overlay-image-ue {\n    top: 50%;\n    left: 70%;\n  }\n\n  .overlay-image-min {\n    top: 70%;\n    left: 70%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
